module.exports = __webpack_public_path__ + "static/Site-10-45afd08fd1231e8ddc419e98139402c2.jpg";